<template>
  <div>
    <b-row>
      <b-col
        v-for="(item,index) in dashboard.counters.account_activities"
        :key="index"
        cols="12"
        md="4"
      >
        <b-overlay
          :show="loading"
          rounded="sm"
          :variant="variant"
          :opacity="opacity"
          :blur="blur"
        >
          <div
            class="cursor-pointer"
            @click="$router.push('/app/account-activities')"
          >
            <account-activities
              :color="item.color"
              :icon="item.icon"
              :sadaka="item.sadaka"
              :statistic-title="item.title"
              :toplam="item.toplam"
              :zekat="item.zekat"
            />
          </div>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCol, BRow, BOverlay,
} from 'bootstrap-vue'
import AccountActivities from '@/views/Dashboard/components/AccountActivities.vue'
// import StatisticCard from '@/views/Dashboard/components/StatisticCard.vue'

export default {
  name: 'Manager',
  components: {
    BOverlay,
    BRow,
    BCol,
    AccountActivities,
    // StatisticCard,
  },
  data() {
    return {
      variant: 'transparent',
      opacity: 0.90,
      blur: '2px',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    dashboard() {
      return this.$store.getters['dashboard/dashboard']
    },
    loading() {
      return this.$store.getters['dashboard/loading']
    },
    filters() {
      return this.$store.getters['dashboard/filters']
    },
  },
  watch: {
    filters: {
      deep: true,
      handler(val) {
        if (val.sdate || val.edate) {
          this.getDashboard()
        }
      },
    },
  },
  created() {
    this.getDashboard()
  },
  methods: {
    getDashboard() {
      this.$store.dispatch('dashboard/getData', this.filters)
    },
  },
}
</script>
